module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b433ee02a13fa2a12f7f7059f1f6729a.svg";